<template>
  <v-app id="inspire">
    <v-main>
      <v-overlay :value="loading"></v-overlay>
      <v-overlay :value="loadingAzureAD"></v-overlay>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <br/><br/>
           <!-- {{ $root.webappData }}-->
            <v-card class="elevation-5"   v-if="$root.webappData && (!$root.webappData.AZUREAD_ACTIVE || $root.webappData.existUserUuid)">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Connectez-vous</v-toolbar-title>
                <v-spacer></v-spacer>
                
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text" v-model="login"
                    required
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock" require
                    type="password" v-model="password" 
                    required
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn @click="validateLogin" color="primary" :loading="loading">Connexion</v-btn>
                
              </v-card-actions>
              
              
            </v-card>

            <v-card class="elevation-5" v-if="$root.webappData &&  ($root.webappData.AZUREAD_ACTIVE && !$root.webappData.existUserUuid)">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Connectez-vous</v-toolbar-title>
                <v-spacer></v-spacer>
                
              </v-toolbar>
              <v-card-text>
              Pour accéder à cette application, vous devrez vous connecter en utilisant vos identifiants Microsoft Azure AD. <br/>
              Veuillez entrer votre adresse email et votre mot de passe Azure Active Directory lors de la connexion.<br/>
             </v-card-text>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn @click="openWebView" color="primary" :loading="loadingAzureAD">CONNEXION</v-btn>
                
              </v-card-actions>
              
              
            </v-card>
          </v-col>
        </v-row>
        <!--
        <div v-if="authCode">
          <p>Authentification réussie. Code d'autorisation : {{ authCode }}</p>
        </div>-->
    </v-main>
  </v-app>
</template>

<script>
  import {UserService} from '../providers/UserService.js';
const userService = new UserService();
export default {
  
    name: 'Connexion',
  data() {
    return {
      login: "",
      password: "",
      loading:false,
      loadingAzureAD:false,
      authCode: null, // Stocke le code d'autorisation reçu
    };
  },
  mounted() {
    // Écouter les messages provenant de la webview (lorsque postMessage est appelé)
    window.addEventListener("message", this.handleMessage, false);
    
  },
  beforeDestroy() {
    // Nettoyer l'écouteur quand le composant est détruit
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
/*
    isAppversionOk: async function (){

      let res = await this.$dialog.error({
                  title: 'Erreur',
                  text: 'Une nouvelle version est disponible.',
                  persistent: true
                });
                if (res === undefined) {
                  document.location.reload(true);
                } else {
                  document.location.reload(true);
                }
    },*/
    
      openWebView() {
        //alert(0)
      // Ouvrir la webview pour lancer le flux d'authentification
      //const authUrl = "http://localhost/sfrwebapp/tests/simuasurad.php"; // L'URL qui lance l'authentification OAuth
      //const authUrl = "https://webapp.lpcybernet.com/simuasurad.php"; // L'URL qui lance l'authentification OAuth
      //const authUrl = "http://localhost/sfrwebapp/tests/webviewazurad.php"; // L'URL qui lance une webview
      const authUrl = this.$root.webappData.AZUREAD_URL_AUTHORIZE;
      console.log("open webview :", authUrl);
      window.open(authUrl, "_blank", "width=500,height=600");
      },
      handleMessage(event) {
        //alert(2);
        // Vérifier la source du message (vous pouvez restreindre cela si nécessaire)
        console.log("handleMessage :",event.origin);
        /*if (event.origin !== "http://localhost") {
          return; // Ne pas traiter les messages d'autres domaines
        }*/
        console.log("event.data :",event.data);
        // Vérifier si le message contient le code d'autorisation
        const  data = event.data;
        if (data && data.code) {
          this.authCode = data.code; // Stocker le code reçu dans le data
          this.connexionAzureAD();
          // connexion azureAd
          console.log("Code d'autorisation reçu :", this.authCode);
        }
      },
      validateLogin:async function(){
        const loginEncrypt = this.$encryptedData(this.$root.public_key,this.login);
        const passwordEncrypt = this.$encryptedData(this.$root.public_key,this.password);
        
        this.loading = true;
        
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_token_expires_at');
        await userService.authenticate().then((res) => {
           
          if (res) {
            if (!res.error && res.params) {
              localStorage.setItem("access_token",res.params.access_token);
              localStorage.setItem("access_token_expires_at",res.params.expires_at);

              //login
              userService.login(loginEncrypt, passwordEncrypt,this.$root.uuid).then(res => { 
                this.loading = false;
                if(res){
                  if (res.err !='error') {
                    if(this.$globalService.isDevicePC(this.$device) &&  
                    (res.params.type=='DGL' || res.params.type=='LPM' || (res.params.type=='VAD' && (res.params.role=='VADEUR' || res.params.role=='ITINERANT')))
                    ){
                      this.$dialog.error({
                          text: "Vous devez utiliser un device mobile pour vous connecter ",
                          title: 'Erreur',
                          persistent: false,
                          actions: {
                            false: 'Fermer'
                          }
                        })
                    }else{
                      this.$emit("login", res.params);
                    }
                              
                  }else{
                    this.$dialog.error({
                      text: res.err_msg,
                      title: 'Erreur',
                      persistent: false,
                      actions: {
                        false: 'Fermer'
                      }
                    })
                  
                  }
                }
              }).catch(error=>{
          
                    this.loading = false;
                    this.$dialog.notify.error(this.$root.errorMessage, {
                              position: 'bottom-right',
                              timeout: 5000
                            })
                  return error;
              })

            }else{
              this.$dialog.notify.error(this.$root.errorMessage, {
                position: "bottom-right",
                timeout: 5000,
              });
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

            
      },
      connexionAzureAD:async function(){
        
        this.loadingAzureAD = true;
        
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_token_expires_at');
        await userService.authenticate().then((res) => {
           
          if (res) {
            if (!res.error && res.params) {
              localStorage.setItem("access_token",res.params.access_token);
              localStorage.setItem("access_token_expires_at",res.params.expires_at);

              //login
              userService.getUserFromAuthCode(this.authCode,this.$root.uuid).then(res => { 
                this.loadingAzureAD = false;
                if(res){
                  if (res.err !='error') {
                    if(this.$globalService.isDevicePC(this.$device) &&  
                    (res.params.type=='DGL' || res.params.type=='LPM' || (res.params.type=='VAD' && (res.params.role=='VADEUR' || res.params.role=='ITINERANT')))
                    ){
                      this.$dialog.error({
                          text: "Vous devez utiliser un device mobile pour vous connecter ",
                          title: 'Erreur',
                          persistent: false,
                          actions: {
                            false: 'Fermer'
                          }
                        })
                    }else{
                      this.$emit("login", res.params);
                    }
                              
                  }else{
                    this.$dialog.error({
                      text: res.err_msg,
                      title: 'Erreur',
                      persistent: false,
                      actions: {
                        false: 'Fermer'
                      }
                    })
                  
                  }
                }
              }).catch(error=>{
          
                    this.loadingAzureAD = false;
                    this.$dialog.notify.error(this.$root.errorMessage, {
                              position: 'bottom-right',
                              timeout: 5000
                            })
                  return error;
              })

            }else{
              this.$dialog.notify.error(this.$root.errorMessage, {
                position: "bottom-right",
                timeout: 5000,
              });
            
            }
          }
        })
        .catch((error) => {
          this.loadingAzureAD = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

            
      }
  }
};
  
</script>
